var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    attrs: {
      "align": "baseline"
    }
  }, [_vm._l(_vm.items, function (_ref) {
    var term = _ref.term,
        desc = _ref.desc;
    return [_c('v-col', {
      key: "".concat(term, "-term"),
      attrs: {
        "cols": "3",
        "md": "2"
      }
    }, [_vm._v(" " + _vm._s(term))]), _c('v-col', {
      key: "".concat(term, "-desc"),
      attrs: {
        "cols": "9",
        "md": "10"
      }
    }, [_vm._v(" " + _vm._s(desc) + " ")])];
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }